import { Button } from "@material-tailwind/react";
import { ReactNode } from "react";

const BaseButton = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) => (
  <Button
  placeholder={undefined}
    className={`mt-5 bg-primary normal-case ${className}`}
    fullWidth
    type="submit"
  >
    {children}
  </Button>
);

export default BaseButton;
